<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content rf-sider">
                <div>
                    <app-saved-dashboard-view></app-saved-dashboard-view>
                </div>
                <div *ngFor="let link of [modify_time_resources_datasource]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>

                <button
                    class="rf-doc-button"
                    nz-button
                    nzType="primary"
                    nzBlock
                    (click)="showDashboardDocumentation()"
                >
                    <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                    Dashboard documentation
                </button>

                <!-- CHART VIEW: client-side (instant, no Apply) -->
                <section class="rf-side-group rf-side-group-instant">
                    <header class="rf-side-group-head">
                        <span class="rf-side-group-title">Chart view</span>
                        <span class="rf-tag rf-tag-instant">instant</span>
                    </header>
                    <p class="rf-side-hint">
                        Updates immediately without running a new query.
                    </p>
                    <div class="rf-side-field">
                        <span class="rf-side-field-label"
                            >Grouping threshold</span
                        >
                        <nz-select
                            [ngModel]="flowState.threshold"
                            (ngModelChange)="flowState.setThreshold($event)"
                            nzSize="small"
                            [nzOptionHeightPx]="25"
                        >
                            <nz-option
                                *ngFor="let t of flowState.thresholdOptions"
                                [nzValue]="t.value"
                                [nzLabel]="t.label"
                            ></nz-option>
                        </nz-select>
                    </div>
                    <label
                        nz-checkbox
                        [ngModel]="flowState.wheelZoom"
                        (ngModelChange)="flowState.setWheelZoom($event)"
                        nz-tooltip
                        nzTooltipTitle="Zoom the charts with the mouse wheel. Turn off to disable."
                    >
                        Scroll to zoom
                    </label>
                </section>

                <!-- DATA FILTERS: server-side (re-query on Apply) -->
                <section class="rf-side-group rf-side-group-apply">
                    <header class="rf-side-group-head">
                        <span class="rf-side-group-title">Data filters</span>
                        <span class="rf-tag rf-tag-apply">requires Apply</span>
                    </header>
                    <p class="rf-side-hint">
                        Configure the metric and filters, then use Apply.
                    </p>

                    <section
                        *ngFor="let section of filterDashboardItemSections"
                        class="rf-filter-subsection"
                        [attr.data-accent]="section.accent"
                    >
                        <div class="rf-side-subsection-title">
                            {{ section.title }}
                        </div>

                        <ng-container *ngIf="section.includesMetricSettings">
                            <app-single-select
                                [option]="currencySetting.options"
                            ></app-single-select>
                            <app-toggle
                                [option]="xAxisSetting.options"
                            ></app-toggle>
                            <app-toggle
                                [option]="accumulationSetting.options"
                                [disabled]="accumulationDisabled"
                            ></app-toggle>
                            <app-single-select
                                [option]="valueModeSetting.options"
                            ></app-single-select>
                            <div class="rf-percentile-toggles">
                                <app-checkbox
                                    [option]="settingShowP50.options"
                                    [disabled]="percentilesDisabled"
                                ></app-checkbox>
                                <app-checkbox
                                    [option]="settingShowP75.options"
                                    [disabled]="percentilesDisabled"
                                ></app-checkbox>
                                <app-checkbox
                                    [option]="settingShowP90.options"
                                    [disabled]="percentilesDisabled"
                                ></app-checkbox>
                                <app-checkbox
                                    [option]="settingShowP99.options"
                                    [disabled]="percentilesDisabled"
                                ></app-checkbox>
                            </div>
                            <app-toggle
                                [option]="userTypeSetting.options"
                            ></app-toggle>
                            <app-toggle
                                [option]="populationSetting.options"
                                [disabled]="populationDisabled"
                            ></app-toggle>
                        </ng-container>

                        <!-- Category filters are splitable unless their factory disables it. -->
                        <ng-container
                            *ngFor="let columnId of section.columnIds"
                        >
                            <div
                                *ngIf="
                                    filterDashboardItemLinks[columnId] as link
                                "
                            >
                                <app-category-filter-dashboard-item
                                    *ngIf="
                                        link.dashboardItemFactory
                                            .componentClass ==
                                        'CategoryFilterDashboardItem'
                                    "
                                    [dashboardItemFactory]="
                                        link.dashboardItemFactory
                                    "
                                    [dataLoaderEmitter]="link.dataLoaderEmitter"
                                >
                                </app-category-filter-dashboard-item>
                                <app-date-picker
                                    *ngIf="
                                        link.dashboardItemFactory
                                            .componentClass ==
                                        'DateRangeFilterDashboardItem'
                                    "
                                    [dashboardItemFactory]="
                                        link.dashboardItemFactory
                                    "
                                    [dataLoaderEmitter]="link.dataLoaderEmitter"
                                ></app-date-picker>
                                <app-segment-filter
                                    *ngIf="
                                        link.dashboardItemFactory
                                            .componentClass ==
                                        'SegmentsFilterDashboardItem'
                                    "
                                    [dashboardItemFactory]="
                                        link.dashboardItemFactory
                                    "
                                    [dataLoaderEmitter]="link.dataLoaderEmitter"
                                ></app-segment-filter>
                                <app-string-input-filter
                                    *ngIf="
                                        link.dashboardItemFactory
                                            .componentClass ==
                                        'StringInputFilterDashboardItem'
                                    "
                                    [dashboardItemFactory]="
                                        link.dashboardItemFactory
                                    "
                                ></app-string-input-filter>
                            </div>
                        </ng-container>
                    </section>
                </section>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="requestNewSegmentsProcessing()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Process new Segments
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>

    <nz-content class="am-dash-main-content">
        <div class="main-container">
            <div class="grid-container">
                <!-- KPI tiles use the full applied range. -->
                <app-kpi-tiles
                    [dashboardItemFactory]="kpiTiles.dashboardItemFactory"
                    [dataLoaderEmitter]="kpiTiles.dataLoaderEmitter"
                ></app-kpi-tiles>

                <!-- flow (two-sided stack) + net (connected) — stock echarts items -->
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="24">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="
                                flowChart.dashboardItemFactory
                            "
                            [dataLoaderEmitter]="flowChart.dataLoaderEmitter"
                            [chartHeight]="'400'"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="24">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="
                                netChart.dashboardItemFactory
                            "
                            [dataLoaderEmitter]="netChart.dataLoaderEmitter"
                            [chartHeight]="'200'"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>

                <nz-divider
                    nzText="Share breakdown"
                    nzOrientation="left"
                ></nz-divider>

                <!-- breakdown = two stock tables (inflow / outflow); a row click toggles its flow series -->
                <div nz-row [nzGutter]="5">
                    <div
                        *ngFor="let breakdown of breakdowns"
                        nz-col
                        nzSpan="12"
                    >
                        <app-table-dashboard-item
                            [dashboardItem]="breakdown.dashboardItem"
                            [dataLoaderEmitter]="breakdown.dataLoaderEmitter"
                            (rowClick)="toggleSeriesFromRow($event)"
                        >
                            <div
                                table-header-actions
                                class="rf-breakdown-actions"
                                role="group"
                                [attr.aria-label]="breakdown.ariaLabel"
                            >
                                <button
                                    nz-button
                                    nzSize="small"
                                    type="button"
                                    (click)="
                                        setBreakdownSideVisibility(
                                            breakdown.direction,
                                            true
                                        )
                                    "
                                >
                                    ALL
                                </button>
                                <button
                                    nz-button
                                    nzSize="small"
                                    type="button"
                                    (click)="
                                        setBreakdownSideVisibility(
                                            breakdown.direction,
                                            false
                                        )
                                    "
                                >
                                    NONE
                                </button>
                                <!-- Client-side: chart order or visible value. -->
                                <button
                                    nz-button
                                    nzSize="small"
                                    type="button"
                                    nz-tooltip
                                    (click)="
                                        flowState.cycleBreakdownSort(
                                            breakdown.direction
                                        )
                                    "
                                >
                                    {{
                                        flowState.breakdownSortLabel(
                                            breakdown.direction
                                        )
                                    }}
                                </button>
                            </div>
                        </app-table-dashboard-item>
                    </div>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
